import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent
} from "@material-ui/core";

import { ITableDeleteCell } from "../../models/shared/IShared";
import {
  StyledDialogTitle,
  StyledDialogLinearProgress,
  StyledDialogContentText
} from "../../components/sharedStyledComponents";

interface IProps {
  deviceInfo: ITableDeleteCell;
  handleDeleteDialogClose: (deviceInfo: ITableDeleteCell) => void;
  deleteDevice: (deviceInfo: ITableDeleteCell) => void;
  isLoading: boolean;
}

export const DeviceDeleteDialog: React.FunctionComponent<IProps> = ({
  deviceInfo,
  handleDeleteDialogClose,
  deleteDevice,
  isLoading
}: IProps) => {
  const DeleteDialogClose = () => {
    handleDeleteDialogClose(deviceInfo);
  };

  const DeleteDevice = () => {
    deleteDevice(deviceInfo);
  };

  return (
    <Dialog
      open={deviceInfo.visible}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <StyledDialogTitle id="alert-dialog-title">
        Are you sure you want to delete this device?
      </StyledDialogTitle>
      <DialogContent>
        <StyledDialogContentText id="alert-dialog-description">
          {deviceInfo.title}
        </StyledDialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={DeleteDialogClose}
          color="primary"
          variant="contained"
          disabled={isLoading}
          autoFocus>
          No
        </Button>
        <Button onClick={DeleteDevice} color="primary" disabled={isLoading}>
          Yes
        </Button>
      </DialogActions>

      {isLoading && <StyledDialogLinearProgress />}
    </Dialog>
  );
};
